<template>
    <div class="page">
        <div class="second-header-wrap">
            <el-select v-model="currentNotice" @change="noticeChange" placeholder="请选择">
                <el-option
                    v-for="noticeItem in noticeList"
                    :key="noticeItem.id"
                    :label="noticeItem.title"
                    :value="noticeItem.id">
                </el-option>
            </el-select>
        </div>
        <div class="data-accounting">
            <div class="header">
                <span class="color-block"></span>
                数据统计
            </div>
            <div class="accounting-item">
                <div class="data-chart" id="signup-chart">
                </div>
                <div class="data-container">
                    <div class="data-item">
                        <span class="data-item__desc">报名人数</span>
                        <span class="data-item__data">{{baseData.enrolCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">资料完整人数</span>
                        <span class="data-item__data">{{baseData.dataCompleteCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">资料不完整人数</span>
                        <span class="data-item__data">{{baseData.dataInCompleteCount}}</span>
                    </div>
                </div>

            </div>
            <div class="accounting-item">
                <div class="data-chart" id="recruit-chart">
                </div>
                <div class="data-container">
                    <div class="data-item">
                        <span class="data-item__desc">录取人数</span>
                        <span class="data-item__data">{{baseData.admitCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">未录取人数</span>
                        <span class="data-item__data">{{baseData.disqualifyCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">录取比例</span>
                        <span class="data-item__data">{{divide(baseData.admitCount, baseData.admitCount + baseData.disqualifyCount, 4) * 100}}%</span>
                    </div>
                </div>
            </div>
            <div class="accounting-item">
                <div class="data-chart" id="gender-chart">
                </div>
                <div class="data-container">
                    <div class="data-item">
                        <span class="data-item__desc">录取男生人数</span>
                        <span class="data-item__data">{{baseData.admitBoyCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">录取女生人数</span>
                        <span class="data-item__data">{{baseData.admitGirlCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">男女比例</span>
                        <span class="data-item__data">{{divide(baseData.admitBoyCount, baseData.admitGirlCount, 2)}}</span>
                    </div>
                </div>

            </div>
            <div class="accounting-item" v-show="fieldNameList.indexOf('isSingleParent') !== -1">
                <div class="data-chart" id="family-chart">
                </div>
                <div class="data-container">
                    <div class="data-item">
                        <span class="data-item__desc">录取单亲家庭人数</span>
                        <span class="data-item__data">{{baseData.uniparentalCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">录取非单亲家庭人数</span>
                        <span class="data-item__data">{{baseData.biparentalCount}}</span>
                    </div>
                    <div class="data-item">
                        <span class="data-item__desc">单亲家庭比例</span>
                        <span class="data-item__data">{{divide(baseData.uniparentalCount, baseData.uniparentalCount + baseData.biparentalCount, 4) * 100}}%</span>
                    </div>
                </div>

            </div>
        </div>
        <div class="birth-accounting" v-show="monthData && monthData.length !== 0">
            <div class="header">
                <span class="color-block"></span>
                出生月份统计
            </div>
            <div class="data-chart" id="birth-chart">
            </div>
            <div class="data-container">
                <div class="data-item" v-for="monthDataItem in monthData">
                    <span class="data-item__desc">{{monthDataItem.birthMonth | monthToText}}</span>
                    <span class="data-item__data">{{monthDataItem.birthMonthCount}}</span>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import echarts from 'echarts';

    import {
        getEnrolAnalysisData,
        getEnrolBirthMonthAnalysisData,
        getSchoolEnrolNoticeList,
        getSchoolEnrolFieldList
    } from '@/api/primary/accounting';

    function drawPieChart(containerId, config) {
        const option = {
            color: [
                "#3fb1e3",
                "#6be6c1",
                "#626c91",
                "#a0a7e6",
                "#c4ebad",
                "#96dee8"
            ],
            avoidLabelOverlap: true,
            tooltip : {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c} ({d}%)"
            },
            legend: {
                data: config.data.map(item => item.name)
            },

            series : [
                {
                    name: config.seriesName,
                    type: 'pie',
                    radius : '65%',
                    center: ['50%', '50%'],
                    data: config.data,
                    label: {
                        normal: {
                            position: config.labelInside ? 'inside' : 'outside',
                            color: '#333'
                        }
                    },
                    itemStyle: {
                        emphasis: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };

        if (document.getElementById(containerId) !== null) {
            console.log(document.getElementById(containerId));
            echarts.init(document.getElementById(containerId)).setOption(option);
        }
    }
    export default {
        name: "dataAccounting",
        data: function() {
            return {
                currentNotice: 0,
                noticeList: [],
                baseData: {},
                monthData: [],
                signupSettingList: [],
                fieldNameList: []
            }
        },
        filters: {
            monthToText(monthValue) {
                return [
                    '',
                    '一月',
                    '二月',
                    '三月',
                    '四月',
                    '五月',
                    '六月',
                    '七月',
                    '八月',
                    '九月',
                    '十月',
                    '十一月',
                    '十二月'
                ][monthValue];
            }
        },
        mounted() {
            getSchoolEnrolFieldList({
                yearNo: moment(new Date()).format('YYYY')
            }).then(res=>res.data)
                .then(data=>{
                    if(data.code===200){
                        const fieldNameList=[];
                        data.data.forEach((item,index)=>{
                            fieldNameList.push(item.fieldName);
                        });
                        this.fieldNameList = fieldNameList;
                    }
                });
            getSchoolEnrolNoticeList({
                searchVal: '',
                state: 2
            })
                .then(res => res.data)
                .then(data => {
                    this.noticeList = data.data;
                    if(data.data.length !== 0) {
                        this.currentNotice = data.data[0].id;
                        this.getEnrolAnalysisDataFunc();
                        this.getEnrolBirthMonthAnalysisDataFunc();
                    }
                });

        },
        methods: {
            divide(arg1, arg2, precision = 0) {
                if(arg2 === 0) {
                    return 0;
                } else {
                    let result = arg1 / arg2;
                    const multiplier = 10 ** precision;
                    return Math.round(result * multiplier) / multiplier;
                }
            },
            noticeChange() {
                this.getEnrolAnalysisDataFunc();
                this.getEnrolBirthMonthAnalysisDataFunc();
            },
            getEnrolAnalysisDataFunc() {
                getEnrolAnalysisData({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const pageData = data.data;
                        this.baseData = pageData;

                        drawPieChart('signup-chart', {
                            labelInside: true,
                            seriesName: '人数',
                            data: [{
                                value: pageData.dataCompleteCount, name: '资料完整人数'
                            }, {
                                value: pageData.dataInCompleteCount, name: '资料不完整人数'
                            }]
                        });
                        drawPieChart('recruit-chart', {
                            labelInside: true,
                            seriesName: '人数',
                            data: [{
                                value: pageData.admitCount, name: '录取'
                            }, {
                                value: pageData.disqualifyCount, name: '未录取'
                            }]
                        });
                        drawPieChart('gender-chart', {
                            labelInside: true,
                            seriesName: '人数',
                            data: [{
                                value: pageData.admitBoyCount, name: '男生'
                            }, {
                                value: pageData.admitGirlCount, name: '女生'
                            }]
                        });
                        drawPieChart('family-chart', {
                            labelInside: true,
                            seriesName: '人数',
                            data: [{
                                value: pageData.uniparentalCount, name: '单亲'
                            }, {
                                value: pageData.biparentalCount, name: '非单亲'
                            }]
                        });
                    });
            },
            getEnrolBirthMonthAnalysisDataFunc() {
                getEnrolBirthMonthAnalysisData({
                    noticeId: this.currentNotice
                })
                    .then(res => res.data)
                    .then(data => {
                        const monthCharMapping = [
                            '',
                            '一月',
                            '二月',
                            '三月',
                            '四月',
                            '五月',
                            '六月',
                            '七月',
                            '八月',
                            '九月',
                            '十月',
                            '十一月',
                            '十二月'
                        ];
                        const pageData = data.data;
                        this.monthData = pageData;
                        const seriesData = pageData.map(({birthMonth, birthMonthCount}) => ({
                            name: monthCharMapping[birthMonth],
                            value: birthMonthCount
                        }));
                        drawPieChart('birth-chart', {
                            seriesName: '人数',
                            data: seriesData
                        });
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .page {
        padding: 15px;
    }
    .accounting-item {
        width: 400px;
        float: left;
        margin-right: 20px;
    }

    .header {
        font-size: 18px;
        border-bottom: 1px solid #20a0ff;
        width: 250px;
        .color-block {
            @include wh(20px, 20px);
            @include middleIB;
            background-color: #20a0ff;
            margin-right: 5px;
        }
        white-space: nowrap;
        margin: 10px 5px 10px 0;
        padding: 0 0 10px 0;
    }
    .second-header-wrap {
        left: 0;
        width: 92%;
        min-width: 1000px;
        height: 60px;
        line-height: 60px;
        padding: 5px 0;
        background-color: #fff;
        z-index: 1000;
    }
    .data-container {
        width: 400px;
        box-sizing: border-box;
        border: 1px solid #409EFF;
        border-radius: 10px;
        padding: 20px;
        font-size: 18px;
        span {
            @include middleIB;

        }
        .data-item__desc {
            width: 70%;
        }
        .data-item__data {
            width: 28%;
        }
    }
    .data-chart {
        margin: 0 auto 10px auto;
        width: 300px;
        height: 300px;
    }
    .birth-accounting {
        clear: both;
        .data-chart {
            float: left;
            width: 500px;
            height: 500px;
            margin-right: 10px;
        }
        .data-container {
            width: 200px;
            float: left;
        }
        .data-item__desc {
            width: 68%;
        }
    }
    .data-accounting {
        @include clearfix;
    }
</style>



// WEBPACK FOOTER //
// src/views/primary/accounting/DataAccounting.vue